import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Profile() {
    // Sample NFT data for demonstration purposes
    const nftItems = [
        { title: 'The Animals', image: 'images/author_single/porto-2.jpg', price: '0.06 TON', likes: 80, status: 'BUY' },
        { title: 'Three Donuts', image: 'images/author_single/porto-3.jpg', price: '0.05 TON', likes: 97, status: 'SOLD' },
        { title: 'Graffiti Colors', image: 'images/author_single/porto-4.jpg', price: '0.02 ETH', likes: 73, status: 'Place a bid' },
        // Add more items as needed
    ];

    return (
        <div id="wrapper">
            
            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">

                <section id="profile_banner" aria-label="section" className="text-light" style={{ backgroundImage: 'url(https://mkpcdn.com/abtbnr/a27336f5712ce2f3149ea6cb70e32de1_303349.jpg)' }}>
                </section>

                <section aria-label="section" style={{ paddingTop: '40px' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="d_profile de-flex">
                                    <div className="de-flex-col">
                                        <div className="profile_avatar_big">
                                            <img src="/images/author/author-11.jpg" alt="" />
                                            <i className="fa fa-check"></i>
                                            <div className="profile_name">
                                                <h4>
                                                <span style={{ marginRight: '80px', verticalAlign: 'sub' }}>DdzFFzCqrhshMSxb9oW...</span> <a href="/edit-profile" className="btn-main profile"><i className='fa fa-pencil'></i> Edit profile</a>
                                                    
                                                    {/* <a href="/edit-profile" className="btn-main profile"><i className='fa fa-check-circle-o'></i> Request verification</a> */}

                                                    <a href="#" className="btn-main profile"><i className='fa fa-plus'></i> Follow</a><span className='followers'>560&nbsp;Followers</span><a href="#" className='social'><img src="/images/instagram.png" /></a><a href="#" className='social'><img src="/images/twitter.png" style={{width: '34px' }}  /></a><a href="#" className='social'><img src="/images/website.png" /></a>

                                                    <span className="profile_username" style={{ display: 'none' }}>@username</span><br />                                                                                   
                                                    <span id="wallet" className="profile_wallet">
                                                        <img src="https://ton.org/download/ton_symbol.svg" style={{ width: '24px', height: '24px', border: 'none', filter: 'grayscale(100%)' }} 
 />  DdzFFzCqrhshMSxb9oW3mRo4MJrQkusV3fGFSTwaiu4wPBqMryA9DYVJCkW9n7twCffG5f5wX2sSkoDXGiZB1HPa7K7f865Kk4LqnrME
                                                    </span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>

                            <div className="col-md-12 submenu">
                                <div className="de_tab tab_simple">
                                    <ul className="de_nav pb30">
                                        <li className="active">
                                            <span>Bio</span>
                                        </li>
                                        <li>
                                            <span>Galleries</span>
                                        </li>
                                        <li>
                                            <span>Collections</span>
                                        </li>
                                        <li>
                                            <span>Listings NFTs</span>
                                        </li>
                                        <li>
                                            <span>Activity</span>
                                        </li>
                                        <li>
                                            <span>Liked</span>
                                        </li>
                                    </ul>

                                    <div className="de_tab_content">
                                        <div className="tab-1 bb">
                                            <div className="row">
                                                <h5>You haven't added a bio yet. Edit profile to add one.</h5>
                                            </div>
                                        </div>
                                        <div className="tab-2 bb">
                                            <div className="row">
                                                <div class="col-md-3 col-lg-4 mb30 item">
                                                    <div class="nft_gall">
                                                        <div class="nft_wrap" >
                                                        </div>
                                                       
                                                        <div className="nft__item_info" style={{padding: '100px' }}>
                                                            <h3><a href="/create-gallery" class="btn-main profile">Create a gallery</a>  </h3>                                                          
                                                        </div>
                                                    </div>
                                                </div>                                            
                                            </div>
                                        </div>
                                        <div className="tab-3 bb">
                                            <div className="row">
                                                <div class="col-md-3 col-lg-4 mb30 item">
                                                    <div class="nft_gall">
                                                        <div class="nft_wrap" >
                                                        </div>
                                                       
                                                        <div className="nft__item_info" style={{padding: '100px' }}>
                                                            <h3><a href="/create-collection" class="btn-main profile">Create a collection</a>  </h3>                                                          
                                                        </div>
                                                    </div>
                                                </div>                                            
                                            </div>
                                        </div>
                                        <div className="tab-4 bb">
                                            <div className="row">
                                            <div class="col-md-3 col-lg-4 mb30 item">
                                                    <div class="nft_gall">
                                                        <div class="nft_wrap" >
                                                        </div>
                                                       
                                                        <div className="nft__item_info" style={{padding: '100px' }}>
                                                            <h3><a href="/create-single" class="btn-main profile">Create your NFT</a>  </h3>                                                          
                                                        </div>
                                                    </div>
                                                </div>                                             
                                            </div>
                                        </div>
                                        <div className="tab-5 bb">
                                            <div className="row">
                                                <h5>No activity.</h5>
                                            </div>
                                        </div>
                                        <div className="tab-6 bb">
                                            <div className="row">
                                                <h5>Coming soon.</h5>
                                            </div>
                                        </div>
                                        {/* Additional tabs could be added here */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            
            {/* Footer */}
            <Footer />

        </div>
    );
}

export default Profile;